import { createState, useState } from '@hookstate/core'
import { Persistence } from '@hookstate/persistence';
import { cloneDeep } from 'lodash';

import { StatusProjects, ListProjects, Project } from '../config/interfaces';

const initialState: StatusProjects = {
  all: undefined,
  review: undefined,
  rejected: undefined,
  onGoing: undefined,
  done: undefined,
  projectId: undefined,
  current: undefined,
};

const projectsState = createState(initialState);
projectsState.attach(Persistence('ProjectsInfo'));

export const setAllProjects = (projects: ListProjects) => {
  const tempProjects = cloneDeep(projects);
  projectsState.all.set(tempProjects);
};

export const setDifferentProjects = (projects: StatusProjects) => {
  const tempProjects = cloneDeep(projects);
  projectsState.set({
    ...initialState,
    ...tempProjects,
  });
}

export const setIdCurrentProject = (projectId: string) => {
  projectsState.projectId.set(projectId);
};

export const setCurrentProject = (project: Project) => {
  projectsState.current.set({ ...project });
};

export const setReviewProjects = (projects: ListProjects) => {
  const tempProjects = cloneDeep(projects);
  projectsState.review.set(tempProjects);
};

export const setRejectedProjects = (projects: ListProjects) => {
  const tempProjects = cloneDeep(projects);
  projectsState.rejected.set(tempProjects);
};

export const setOnGoingProjects = (projects: ListProjects) => {
  const tempProjects = cloneDeep(projects);
  projectsState.onGoing.set(tempProjects);
};

export const setDoneProjects = (projects: ListProjects) => {
  const tempProjects = cloneDeep(projects);
  projectsState.done.set(tempProjects);
};

export const useProjectsState = () => useState(projectsState);
